import { FlexProps, useColorModeValue, useMediaQuery } from '@chakra-ui/react'
import { MotionProps, Variants } from 'framer-motion'
import React from 'react'
import { theme } from '../../theme'
import MotionFlex from '../MotionFlex'

export type CardProps = FlexProps &
  MotionProps & {
    shouldAnimate?: boolean
    elevated?: boolean
  }

const Card = React.forwardRef<HTMLElement | SVGElement, CardProps>(
  ({ children, shouldAnimate, border, shadow, elevated, ...rest }, ref) => {
    const variants: Variants = {
      show: {
        y: 0,
        opacity: 1
      },
      hide: {
        y: 50,
        opacity: 0
      }
    }
    const borderThemeColor = useColorModeValue('gray.100', 'gray.800')
    const [isMobileOrTable] = useMediaQuery('(max-width: 40em)')
    const shadowColor = useColorModeValue('rgba(149, 157, 165, 0.1)', 'rgba(0, 0, 0, 0.1)')
    const bg = useColorModeValue('white', 'gray.800')

    return (
      <MotionFlex
        ref={ref}
        animate="show"
        initial="hide"
        variants={shouldAnimate ? variants : {}}
        border={border ? border : '1px solid'}
        borderColor={borderThemeColor}
        shadow={isMobileOrTable ? 'none' : shadow ? shadow : `${shadowColor} 0px 8px 24px`}
        {...(elevated && {
          border: 'none',
          boxShadow: theme.boxShadow2,
          rounded: 'md',
          bg,
          shadow: 'none',
          width: '100%'
        })}
        {...rest}
      >
        {children}
      </MotionFlex>
    )
  }
)

Card.defaultProps = {
  width: 'auto',
  shouldAnimate: true,
  shadow: 'none',
  bg: theme.transparency,
  backdropFilter: 'blur(5px)',
  lineHeight: '24px',
  onClick: () => false,
  flexDirection: 'column'
}

export default Card
